import { Route, Check } from "lucide-react";
import DashboardSectionCard from "@/components/dashboard/DashboardSectionCard";
import DashboardCardAction from "@/components/dashboard/DashboardCardAction";
import { cn, STATUSES } from "@/lib/utils";
import { useLang } from "@/i18n";

export default function AthleteJourneyCard({ athlete }) {
  const { t, tf } = useLang();
  const journey = athlete?.journey || {};
  const currentIdx = STATUSES.indexOf(journey.current);
  const sinceDays = journey.since_days;

  return (
    <DashboardSectionCard
      title={tf("Parcours")}
      icon={Route}
      iconClass="text-muted-foreground"
      testid="card-athlete-journey"
      className="lg:min-h-[520px] xl:min-h-0 xl:h-[clamp(470px,31vw,570px)]"
      footer={
        <DashboardCardAction to="/pipeline" testid="journey-open-pipeline">
          {tf("Ouvrir le pipeline")}
        </DashboardCardAction>
      }
    >
      <ol className="flex-1 flex flex-col justify-center gap-0 pt-2" data-testid="journey-steps">
        {STATUSES.map((st, i) => {
          const done = currentIdx >= 0 && i < currentIdx;
          const current = i === currentIdx;
          return (
            <li key={st} className="flex gap-3" data-testid={`journey-step-${st}`}>
              <div className="flex flex-col items-center">
                <span
                  className={cn(
                    "h-7 w-7 rounded-full border flex items-center justify-center text-[10px] font-bold shrink-0 transition-colors motion-reduce:transition-none",
                    done && "bg-success/15 border-success/40 text-success",
                    current && "bg-athlynx border-athlynx text-white",
                    !done && !current && "bg-secondary/60 border-border text-muted-foreground/50"
                  )}
                  aria-hidden
                >
                  {done ? <Check className="h-3.5 w-3.5" /> : current ? "●" : i + 1}
                </span>
                {i < STATUSES.length - 1 && (
                  <span className={cn("w-px flex-1 min-h-[14px]", done ? "bg-success/40" : "bg-border")} aria-hidden />
                )}
              </div>
              <div className={cn("pb-3 min-w-0", i === STATUSES.length - 1 && "pb-0")}>
                <p className={cn(
                  "text-sm leading-7 truncate",
                  current ? "font-semibold text-foreground" : done ? "text-foreground/80" : "text-muted-foreground/60"
                )}>
                  {t(`status.${st}`)}
                  <span className="sr-only">{done ? ` — ${tf("étape complétée")}` : current ? ` — ${tf("étape actuelle")}` : ""}</span>
                </p>
                {current && sinceDays !== null && sinceDays !== undefined && (
                  <p className="text-[11px] text-muted-foreground" data-testid="journey-since">
                    {tf("Depuis")} {sinceDays} {sinceDays > 1 ? tf("jours") : tf("jour")}
                  </p>
                )}
              </div>
            </li>
          );
        })}
      </ol>
      {currentIdx === -1 && (
        <p className="text-xs text-muted-foreground text-center pb-2" data-testid="journey-unknown">
          {tf("Statut hors pipeline")} : {journey.current || "—"}
        </p>
      )}
    </DashboardSectionCard>
  );
}
